<template>
    <div>
        <div v-if="step" class="text-center">
            <!-- Show table for parcels in PRA -->
            <table class="table table-responsive">
                <thead>
                    <tr>
                        <th>{{ $t("general:re_key") }}</th>
                        <th>{{ $t("amas:analysis:pra:public_road") }}</th>
                        <th>{{ $t("amas:analysis:pra:legal_access") }}</th>
                        <th>{{ $t("amas:analysis:pra:physical_access") }}</th>
                    </tr>
                </thead>
                <tbody>
                    <access-table-row
                        v-if="real_estate && real_estate !== 'loading'"
                        :step="step"
                        :real_estate="real_estate"
                        :public_road="step.has_public_road"
                        :minimal="true"
                        @remove_step="$emit('remove_step', property_id)"                                        
                    />
                    <tr v-else>
                        <td colspan="4" class="text-center">
                            <span class="fa fa-spinner fa-spin"></span> {{ $t("general:loading") }}...
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else class="text-center">
            <!-- Show add/remove for parcels not in PRA -->
            <p>{{ $t("amas:analysis:pra:parcel_id") }}
                <template v-if="parcel">
                    '{{parcel.property_id}}'
                </template>
                <template v-else>
                    <span class="fa fa-spinner fa-spin"></span>
                </template>
            </p>
            
            <span v-if="parcel && canAdd"
                v-tooltip="$t('amas:analysis:pra:add_to_access')" 
                class="btn btn-xs btn-outline btn-rounded btn-info m-b-10"
                @click="$emit('add_step', parcel.property_id)"
            >
                {{ $t("general:add") }}
            </span>
            <span v-else-if="parcel && canRemove"
                v-tooltip="$t('amas:analysis:pra:remove_from_access')" 
                class="btn btn-xs btn-outline btn-rounded btn-danger m-b-10"
                @click="$emit('remove_step', parcel.property_id)"
            >
                {{ $t("general:remove") }}
            </span>
        </div>
    </div>
</template>

<script>
import AccessTableRow from "./AccessTableRow.vue"

export default {
    name: "PRAPopupTable",
    components: {
        AccessTableRow
    },
    props: {
        step: {
            type: Object,
            default: null
        },
        real_estate: {
            type: [Object, String],
            default: null
        },
        parcel: {
            type: Object,
            default: null
        },
        property_id: {
            type: [String, Number],
            default: null
        },
        canAdd: {
            type: Boolean,
            default: false
        },
        canRemove: {
            type: Boolean,
            default: false
        }
    },
    emits: ["add_step", "remove_step"]
}
</script>
